import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { PaginatedResponse } from '@core/api/dtos/common/types'
import { Reseller } from '@core/api/entities/reseller'
import { ResellerMapper } from '@core/api/mappers/resellerMapper'
import resellerService from '@core/api/services/resellerService'

import { DEFAULT_PARAMS } from './common'

export const useResellers = ({
	config,
	options,
}: any = DEFAULT_PARAMS): UseQueryResult<
	PaginatedResponse<Reseller>,
	Error
> => {
	const QUERY_KEY = ['resellers', { ...config?.params }]

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			resellerService.getResellers(config).then(({ data: response }) => ({
				data: ResellerMapper.toEntities(response.data),
				meta: response.meta,
			})),
		cacheTime: 0,
		staleTime: 0,
		...options,
	})
}
